var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-row",
    { staticClass: "bg-white shadow py-5 px-3 mb-4" },
    [
      _c(
        "vs-col",
        { attrs: { "vs-lg": "11" } },
        [
          _c(
            "vs-row",
            [
              _c(
                "vs-col",
                { staticClass: "text-center", attrs: { "vs-lg": "1" } },
                [_c("b", [_vm._v("#")])]
              ),
              _c("vs-col", { attrs: { "vs-lg": "2" } }, [
                _c("b", [_vm._v("Estado")])
              ]),
              _c(
                "vs-col",
                { attrs: { "vs-lg": "9" } },
                [
                  _c(
                    "vs-row",
                    [
                      _c("vs-col", { attrs: { "vs-lg": "4" } }, [
                        _c("b", [_vm._v("En flujo")])
                      ]),
                      _c("vs-col", { attrs: { "vs-lg": "4" } }, [
                        _c("b", [_vm._v("Enviado por")])
                      ]),
                      _c("vs-col", { attrs: { "vs-lg": "4" } }, [
                        _c("b", [_vm._v("Último aprob.")])
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "vs-col",
        {
          staticClass: "text-center",
          attrs: { "vs-lg": "1", "vs-sm": "4", "vs-xs": "12" }
        },
        [_c("b", [_vm._v("...")])]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }